
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";



import BiCheckBox from '../../uic/controls/BiCheckBox';
import BiTextBox from '../../uic/controls/BiTextBox';
import BiLabel from '../../uic/controls/BiLabel';

import BiFormTable from '../../uic/formTable/BiFormTable';
import BiFormRow from '../../uic/formTable/BiFormRow';
import BiFormCell from '../../uic/formTable/BiFormCell';
import BiFormSection from '../../uic/formTable/BiFormSection';
import BiCheckBoxList from "../../uic/controls/BiCheckBoxList";
import BiTextArea from "../../uic/controls/BiTextArea";
import useFetch from "../../helpers/useFetch";
import BiComboBox from "../../uic/controls/BiComboBox";
import BiAutoCB from "../../uic/controls/BiAutoCB";
import BiFileUpload from "../../uic/controls/BiFileUpload";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid";
import BiDatePicker from '../../uic/controls/BiDatePicker';

const PrijavniObrazec = ({
    idObrazca,
    obrazec,
    onObrazecChanged,
    onObrazecCBListChanged,
    onObrazecTableChange,
    admin,
    disabled,
    onObrazecDatotekeAdd,
    onObrazecDatotekeRemove

}) => {
    const { data: pravneOblike } = useFetch('api/sifranti/getMiniSifrant?tip=TIPSTRANKE', true);
    const { data: dejavnost } = useFetch('api/sifranti/getMiniSifrant?tip=DEJAVNOST', true);
    const getObrazecSprememba = (prop) => {
        if (obrazec.idStranke == 3934) {
            return null;
        }
        if (prop == "podpisnik" && (obrazec[prop] == null || obrazec[prop].length == 0)) {
            return { border: "1px solid red", borderRadius: "4px" };
        }

        if (admin == true) {

            if (obrazec[prop + "Sprememba"] == true) {
                return { border: "2px solid red", borderRadius: "4px" };
            }
        }

    }

    return (

        <Fragment >

            {obrazec &&


                <form className="form" >


                    <BiFormTable responsive={true} columns={[
                        { width: "col-lg-2" },
                        { width: "col-lg-6" },
                        { width: "col-lg-2" },
                    ]}>
                        <BiFormSection responsive={true} show={true} label="Osnovni podatki" icon="fas fa-calendar-plus" >
                            <BiFormRow responsive={true} divider={true}></BiFormRow>

                            {admin &&
                                <Fragment >

                                    <BiFormRow responsive={true}>
                                        <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-globe">Obstoječa stranka Kon-cert:</BiLabel></BiFormCell>
                                        <BiFormCell responsive={true}>
                                            <BiCheckBox style="1" disabled={disabled} name="obstojecaStranka" label="" selected={obrazec.obstojecaStranka} onChange={onObrazecChanged} help={true} help={true}></BiCheckBox>
                                        </BiFormCell>
                                    </BiFormRow>

                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-calendar-days">Datum oddaje:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                            <BiDatePicker name="datumPotrditve" value={obrazec.datumPotrditve ?? new Date()} onChange={onObrazecChanged} ></BiDatePicker>

                                    </BiFormCell>
                                    </BiFormRow>

                                    <BiFormRow responsive={true} divider={true}></BiFormRow>

                                </Fragment>
                            }
                            {obrazec.pIdTipObrazca != 3 && admin &&
                                <Fragment >

                                    <BiFormRow responsive={true} >
                                        <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-calendar-days">Datum odstopa:</BiLabel></BiFormCell>
                                        <BiFormCell responsive={true} >
                                            <BiDatePicker name="datumOdstopa" value={obrazec.datumOdstopa} onChange={onObrazecChanged} ></BiDatePicker>

                                        </BiFormCell>
                                    </BiFormRow>
                                    <BiFormRow responsive={true} divider={true}></BiFormRow>
                                </Fragment>
                            }
                            {admin &&
                                <Fragment >

                                    <BiFormRow responsive={true} >
                                        <BiFormCell responsive={true} ><BiLabel icon="fa-regular fa-user">Obdelal:</BiLabel></BiFormCell>
                                        <BiFormCell responsive={true} >
                                            <BiTextBox name="potrdil" disabled={true} value={obrazec.potrdil} onChange={onObrazecChanged} ></BiTextBox>

                                        </BiFormCell>
                                    </BiFormRow>
                                    <BiFormRow responsive={true} divider={true}></BiFormRow>
                                </Fragment>
                            }

                            {admin &&
                                <Fragment >

                                    <BiFormRow responsive={true} >
                                        <BiFormCell responsive={true} ><BiLabel icon="fa-regular fa-user">Vpisal:</BiLabel></BiFormCell>
                                        <BiFormCell responsive={true} >
                                            <BiTextBox name="potrdil" disabled={true} value={obrazec.vpisal} onChange={onObrazecChanged} ></BiTextBox>

                                        </BiFormCell>
                                    </BiFormRow>
                                    <BiFormRow responsive={true} divider={true}></BiFormRow>
                                </Fragment>
                            }

                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fas fa-book-reader">Naziv (priimek in ime):</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="255" disabled={disabled} name="naziv" value={obrazec.naziv} onChange={onObrazecChanged} style={getObrazecSprememba("naziv")} ></BiTextBox>

                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fas fa-regular fa-address-book">Naslov:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="255" disabled={disabled} name="naslov" value={obrazec.naslov} onChange={onObrazecChanged} style={getObrazecSprememba("naslov")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fas fa-thin fa-city">Pošta:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiAutoCB
                                        skipAuth={ true}
                                        online={true}
                                        onlineID="POSTE"
                                        disabled={disabled}
                                        placeholder="Vpišite pošto"
                                        item={obrazec.postaSif}
                                        onItemSelected={onObrazecChanged}
                                        name="postaSif">
                                    </BiAutoCB>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-fingerprint">Matična številka:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="20" disabled={disabled} name="emso" value={obrazec.emso} onChange={onObrazecChanged} style={getObrazecSprememba("emso")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-regular fa-id-badge">Davčna številka (brez SI):</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="20" disabled={disabled} name="davcnaStevilka" numeric="true" maxlength="8" value={obrazec.davcnaStevilka} onChange={onObrazecChanged} style={getObrazecSprememba("davcnaStevilka")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-regular fa-user">Odgovorna oseba:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="100" disabled={disabled} name="odgovornaOseba" value={obrazec.odgovornaOseba} onChange={onObrazecChanged} style={getObrazecSprememba("odgovornaOseba")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fas fa-thin fa-person">Pooblaščena oseba:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="100" disabled={disabled} name="pooblascenaOseba" value={obrazec.pooblascenaOseba} onChange={onObrazecChanged} style={getObrazecSprememba("pooblascenaOseba")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-user-plus">Podpisnik:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <div id="podpisnik">
                                        <BiTextBox maxlength="100" disabled={disabled} name="podpisnik" value={obrazec.podpisnik} onChange={onObrazecChanged} style={getObrazecSprememba("podpisnik")} ></BiTextBox>
                                    </div>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fas fa-thin fa-person">Nosilec dopolnilne dejavnosti:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="250" disabled={disabled} name="nosilecDopolnilneDejavnosti" value={obrazec.nosilecDopolnilneDejavnosti} onChange={onObrazecChanged} style={getObrazecSprememba("nosilecDopolnilneDejavnosti")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fas fa-regular fa-mobile">Mobilni telefon:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="30" disabled={disabled} name="mobilniTelefon" value={obrazec.mobilniTelefon} onChange={onObrazecChanged} style={getObrazecSprememba("mobilniTelefon")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fas fa-regular fa-phone">Telefon:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="30" disabled={disabled} name="telefon" value={obrazec.telefon} onChange={onObrazecChanged} style={getObrazecSprememba("telefon")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fas fa-regular fa-at">Elektronski naslov:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="100" disabled={disabled} name="email" value={obrazec.email} onChange={onObrazecChanged} style={getObrazecSprememba("email")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-regular fa-building">Pravno organizacijska oblika:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiComboBox disabled={disabled} item={obrazec.pravnaOblikaSif} items={pravneOblike} onItemSelected={onObrazecChanged} name="pravnaOblikaSif" ></BiComboBox>

                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-square-person-confined">Tip dejavnosti:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiComboBox disabled={disabled} item={obrazec.tipDejavnostiSif} items={dejavnost} onItemSelected={onObrazecChanged} name="tipDejavnostiSif" ></BiComboBox>

                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-regular fa-registered">KMG-MID:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="20" disabled={disabled} name="kmgMid" numeric="true" value={obrazec.kmgMid} onChange={onObrazecChanged} style={getObrazecSprememba("kmgMid")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-brands fa-chrome">Naslov spletne strani:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="100" disabled={disabled} name="spletnaStran" value={obrazec.spletnaStran} onChange={onObrazecChanged} style={getObrazecSprememba("spletnaStran")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-cart-shopping">Naslov spletne trgovine:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextBox maxlength="100" disabled={disabled} name="spletnaTrgovina" value={obrazec.spletnaTrgovina} onChange={onObrazecChanged} style={getObrazecSprememba("spletnaTrgovina")} ></BiTextBox>
                                </BiFormCell>
                            </BiFormRow>
                            {/*<BiFormRow responsive={true} >*/}
                            {/*    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-tractor">Naslov kmetije-domače ime:</BiLabel></BiFormCell>*/}
                            {/*    <BiFormCell responsive={true} >*/}
                            {/*        <BiTextBox disabled={disabled} name="domaceIme" value={obrazec.domaceIme} onChange={onObrazecChanged} style={getObrazecSprememba("domaceIme")} ></BiTextBox>*/}
                            {/*    </BiFormCell>*/}
                            {/*</BiFormRow>*/}

                            {/*prijavni obrazec EKO*/}
                            {(obrazec.pIdTipObrazca == 1 || obrazec.pIdTipObrazca == 7) &&
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-hashtag">Številka odločbe o registraciji dopolnilne dejavnosti na KMG:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox maxlength="20" disabled={disabled} name="stevilkaOdlocbe" value={obrazec.stevilkaOdlocbe} onChange={onObrazecChanged} style={getObrazecSprememba("stevilkaOdlocbe")} ></BiTextBox>
                                    </BiFormCell>
                                </BiFormRow>
                            }

                            {/*prijavni obrazec IP*/}
                            {obrazec.pIdTipObrazca == 4 &&
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-hashtag">Naslov (če se le-ta razlikuje od naslova KMG/fizične osebe/podjetja):</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox maxlength="255" disabled={disabled} name="naslov2" value={obrazec.naslov2} onChange={onObrazecChanged} style={getObrazecSprememba("naslov2")} ></BiTextBox>
                                    </BiFormCell>
                                </BiFormRow>
                            }
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-list">Opomba:</BiLabel></BiFormCell>
                                <BiFormCell responsive={true} >
                                    <BiTextArea maxlength="4000" disabled={disabled} name="opomba" value={obrazec.opomba} onChange={onObrazecChanged} style={getObrazecSprememba("opomba")} ></BiTextArea>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                        </BiFormSection>

                        {admin &&
                            <Fragment >
                                <BiFormSection responsive={true} show={true} label="Dopolnite" icon="fas fa-sort-amount-up-alt">
                                    <BiFormRow divider={true}></BiFormRow>
                                    <BiFormRow>

                                        <BiFormCell colSpan="3">

                                            <BiCheckBoxList disabled={disabled} name="dopolnitveIzbira" items={obrazec.dopolnitveIzbira} onChange={onObrazecCBListChanged}></BiCheckBoxList>

                                        </BiFormCell>
                                    </BiFormRow>
                                    <BiFormRow divider={true}></BiFormRow>
                                    <BiFormRow divider={true}></BiFormRow>
                                    <BiFormRow divider={true}></BiFormRow>
                                </BiFormSection>
                            </Fragment>
                        }
                        {/*prijavni obrazec EKO, EPR*/}
                        {(obrazec.pIdTipObrazca == 1 || obrazec.pIdTipObrazca == 7) &&
                            <BiFormSection responsive={true} show={true} label="Kategorije" icon="fas fa-sort-amount-up-alt">
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >

                                    <BiFormCell responsive={true} col="col-sm-12">
                                        <div style={getObrazecSprememba("kategorije")}>
                                            <BiCheckBoxList disabled={disabled} name="kategorijeIzbira" items={obrazec.kategorijeIzbira} onChange={onObrazecCBListChanged}></BiCheckBoxList>
                                        </div>
                                    </BiFormCell>
                                </BiFormRow>
                            </BiFormSection>
                        }

                        {/*prijavni obrazec EKO, EPR*/}
                        {(obrazec.pIdTipObrazca == 1 || obrazec.pIdTipObrazca == 7) &&
                            <BiFormSection responsive={true} show={true} label="Dejavnosti" icon="fas fa-sort-amount-up-alt">
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >

                                    <BiFormCell responsive={true} col="col-sm-12">
                                        <div style={getObrazecSprememba("dejavnosti")}>
                                            <BiCheckBoxList disabled={disabled} name="dejavnostiIzbira" items={obrazec.dejavnostiIzbira} onChange={onObrazecCBListChanged}></BiCheckBoxList>
                                        </div>
                                    </BiFormCell>
                                </BiFormRow>

                            </BiFormSection>
                        }

                        {/*prijavni obrazec IP*/}
                        {obrazec.polscine.length != 0 && obrazec.pIdTipObrazca == 4 &&
                            <BiFormSection responsive={true} show={true} label="Način integrirane pridelave, ki ga prijavljate v postopek (vpišite zahtevane podatke):" icon="fas fa-calendar-plus" >
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >

                                    <BiFormCell responsive={true} col="col-lg-12" >
                                        <div style={{ minHeight: "160px" }} >
                                            <BiDataGrid
                                                items={obrazec.polscine}
                                                name="polscine"
                                                mainKey="pIdObrazcaPrijaveIpKolicine"
                                                onSelectedItemChanged={onObrazecTableChange}
                                                columns={[
                                                    { label: "ID", key: "pIdObrazcaPrijaveIpKolicine", type: "decimal", width: "50px" },
                                                    { label: "Način pridelave", key: "pnaziv", type: "string", width: "130px" },
                                                    { label: "Površina v ha", key: "kolicina", type: "decimal", width: "100px", format: "0.00[0000]", align: "right", editable: !disabled },
                                                    { label: "Zapis*", key: "vrstePolscin", type: "string", width: "100%", align: "left", editable: !disabled},

                                                ]}

                                            ></BiDataGrid>
                                        </div>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} col="col-lg-16"><BiLabel>*vrste poljščin (koruza, ječmen, …), vrsta zelenjave (solata, čebula, …), sadna vrsta (jabolka, hruške, …), grozdje (sorta vinske trte)</BiLabel></BiFormCell>
                                </BiFormRow>

                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >

                                    <BiFormCell responsive={true} col="col-lg-12" >
                                        <div style={{ minHeight: "160px" }} >
                                            <BiDataGrid
                                                items={obrazec.polscine}
                                                name="polscine"
                                                mainKey="pIdObrazcaPrijaveIpKolicine"
                                                onSelectedItemChanged={onObrazecTableChange}
                                                columns={[
                                                    { label: "ID", key: "pIdObrazcaPrijaveIpKolicine", type: "decimal", width: "50px" },
                                                    { label: "Način pridelave", key: "pnaziv", type: "string", width: "130px" },
                                                    { label: "Številka GERK-PID*", key: "gerkPid", type: "string", width: "100%", align: "left", editable: !disabled },
                                                    ]}

                                            ></BiDataGrid>
                                        </div>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} col="col-lg-16"><BiLabel>*Številka GERK-PID</BiLabel></BiFormCell>
                                </BiFormRow>
                            </BiFormSection>


                        }

                        {/*prijavni obrazec ZPŽ*/}
                        {obrazec.dejavnostizpz.length != 0 && obrazec.pIdTipObrazca == 5 &&
                            <BiFormSection responsive={true} show={true} label="Ime zaščitenega kmetijskega pridelka oziroma živila:" icon="fas fa-calendar-plus" >
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >

                                    <BiFormCell responsive={true} col="col-lg-12" >
                                        <div style={{ minHeight: "140px" }} >
                                            <BiDataGrid
                                                items={obrazec.dejavnostizpz}
                                                name="dejavnostizpz"
                                                mainKey="pIdPrijavniObrazecZpzDejavnosti"
                                                onSelectedItemChanged={onObrazecTableChange}
                                                columns={[
                                                    { label: "ID", key: "pIdPrijavniObrazecZpzDejavnosti", type: "decimal", width: "50px" },
                                                    { label: "Priznana zaščita", key: "pnaziv", type: "string", width: "300px" },
                                                    { label: "Pridelek ali živilo* (dopiši)", key: "pridelek", type: "string", width: "100%", align: "left", editable: !disabled },

                                                ]}

                                            ></BiDataGrid>
                                        </div>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                            </BiFormSection>
                        }

                        {/*prijavni obrazec IK*/}
                        {obrazec.pIdTipObrazca == 6 &&
                            <BiFormSection responsive={true} show={true} label="Izbrana kakovost" icon="fas fa-calendar-plus" >
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true}>
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-futbol">Pridelava mleka:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true}>
                                        <BiCheckBox style="1" disabled={disabled} name="pridelavaMleka" label="" selected={obrazec.pridelavaMleka} onChange={onObrazecChanged} help={true} help={true}></BiCheckBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-font">Pridelava sadja:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox maxlength="255" disabled={disabled} name="pridelavaSadja" value={obrazec.pridelavaSadja} onChange={onObrazecChanged} ></BiTextBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-font">Reja živali:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox maxlength="255" disabled={disabled} name="rejaZivali" value={obrazec.rejaZivali} onChange={onObrazecChanged} ></BiTextBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true}>
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-futbol">Distribucija:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true}>
                                        <BiCheckBox style="1" disabled={disabled} name="distribucija" label="" selected={obrazec.distribucija} onChange={onObrazecChanged} help={true} help={true}></BiCheckBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true}>
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-futbol">Trženje:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true}>
                                        <BiCheckBox style="1" disabled={disabled} name="trzenje" label="" selected={obrazec.trzenje} onChange={onObrazecChanged} help={true} help={true}></BiCheckBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true}>
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-futbol">Predelava mleka:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true}>
                                        <BiCheckBox style="1" disabled={disabled} name="predelavaMleka" label="" selected={obrazec.predelavaMleka} onChange={onObrazecChanged} help={true} help={true}></BiCheckBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true}>
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-futbol">Predelava sadja:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true}>
                                        <BiCheckBox style="1" disabled={disabled} name="predelavaSadja" label="" selected={obrazec.predelavaSadja} onChange={onObrazecChanged} help={true} help={true}></BiCheckBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true}>
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-futbol">Obrat:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true}>
                                        <BiCheckBox style="1" disabled={disabled} name="obrat" label="" selected={obrazec.obrat} onChange={onObrazecChanged} help={true} help={true}></BiCheckBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true}>
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-futbol">Označba IK:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true}>
                                        <BiCheckBox style="1" disabled={disabled} name="oznacbaIk" label="" selected={obrazec.oznacbaIk} onChange={onObrazecChanged} help={true} help={true}></BiCheckBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-font">Drugo:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox maxlength="255" disabled={disabled} name="drugo" value={obrazec.drugo} onChange={onObrazecChanged} ></BiTextBox>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                            </BiFormSection>
                        }

                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                    </BiFormTable>
                </form>


            }
        </Fragment>
    );

}

export default PrijavniObrazec;